export default "__VITE_ASSET__5b92963b__"